export default (axios) => ({
  async getStatusProgress(utoken) {
    try {
      const response = await axios({
        method: 'GET',
        url: 'viewer/progress',
        headers: {
          utoken: utoken
        }
      });
      response.data.evolution = Number(response.data.evolution.toFixed(0));
      return response;
    } catch (error) {
      console.log('getStatusProgress -> ', error);
    }
  },
  async getMyProgress(utoken, distributorId, page, pageSize) {
    try {
      const response = await axios({
        method: 'GET',
        url: `distributor/${distributorId}/content/all/${page}/${pageSize}?usePPC=true`,
        headers: {
          utoken: utoken
        }
      });
      response.data.content = this.mapperMyProgress(response.data.content);
      return response.data;
    } catch (error) {
      console.error('getMyProgress -> ', error);
    }
  },
  mapperMyProgress(content) {
    console.log(content);
    const mapperContent = [];
    content.forEach((i) => {
      const item = {
        id: i.id,
        name: i.name,
        progressStatus: i.progressStatus,
        progress: i.watchedPercentage,
        grade: i.userGrade,
        questionnaireGrade: i.questionnaireGrade,
        certificateStatus: i.certificateStatus,
        questionnaireCount: i.questionnaireCount,
      };
      mapperContent.push(item);
    });
    return mapperContent;
  }
});
